import React, { useEffect } from 'react';
import styled from 'styled-components';

const ViewerContainer = styled.div`
  border: 6px solid #000;
  background: #fff;
  border-radius: 4px;
  box-shadow: 8px 8px 0 #000;
  padding: 20px;
  position: relative;
  margin: 40px auto;
  max-width: 900px;
`;

export const RedesignComicViewer: React.FC = () => {
  useEffect(() => {
    // Relying on the global comic.js if it's loaded in App, but wait:
    // the prompt said "they must render without the old Navbar/Footer/GlobalStyles".
    // I should make sure turn.js/comic.js scripts are loaded if they aren't.
    // The instructions say "Do not modify the existing home page", but comic.js relies on specific IDs.
    if (!(window as any).jQuery) {
      const jq = document.createElement('script');
      jq.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
      document.body.appendChild(jq);
      jq.onload = () => {
        const turn = document.createElement('script');
        turn.src = 'https://cdnjs.cloudflare.com/ajax/libs/turn.js/3/turn.min.js';
        document.body.appendChild(turn);
        turn.onload = () => {
          const pdf = document.createElement('script');
          pdf.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
          document.body.appendChild(pdf);
          pdf.onload = () => {
            const comic = document.createElement('script');
            comic.src = '/comic.js';
            document.body.appendChild(comic);
          };
        };
      };
    } else {
      // already loaded
      if (!(window as any).comicPrevPage) {
        const comic = document.createElement('script');
        comic.src = '/comic.js';
        document.body.appendChild(comic);
      }
    }
  }, []);

  return (
    <ViewerContainer>
      <div id="comic-viewer" className="comic__viewer-wrapper" style={{ minHeight: 400 }}>
        <div id="comic-loading" className="comic__loading" style={{ textAlign: 'center', fontFamily: 'GROBOLD' }}>
          <div>Loading...</div>
          <div className="comic__progress-container" style={{ border: '2px solid #000', margin: '20px auto', width: '80%', height: '20px' }}>
            <div className="comic__progress-bar" style={{width: '0%', background: '#F7E03C', height: '100%'}}></div>
          </div>
        </div>
        <div className="comic__flipbook-wrapper" style={{display: 'none', margin: '0 auto'}}>
          <div id="comic-flipbook" className="comic__flipbook"></div>
        </div>
      </div>
      <div id="comic-controls" className="comic__controls" style={{display: 'none', textAlign: 'center', marginTop: 20}}>
        <button id="comic-prev-btn" style={{ padding: '10px 20px', fontSize: 20, cursor: 'pointer', background: '#F7E03C', border: '4px solid #000', marginRight: 10 }} onClick={() => (window as any).comicPrevPage?.()}>◀️</button>
        <button id="comic-next-btn" style={{ padding: '10px 20px', fontSize: 20, cursor: 'pointer', background: '#F7E03C', border: '4px solid #000' }} onClick={() => (window as any).comicNextPage?.()}>▶️</button>
      </div>
      <div id="comic-page-info" style={{display: 'none', textAlign: 'center', marginTop: 10, fontFamily: 'GROBOLD'}}></div>
    </ViewerContainer>
  );
};
